// extracted by mini-css-extract-plugin
module.exports = {"coverAuthor":"BookAuthor__coverAuthor","authorList":"BookAuthor__authorList","authorName":"BookAuthor__authorName","link":"BookAuthor__link"};